import React from 'react';
import { Phone, Zap, CheckCircle, Wrench, Shield, MapPin } from 'lucide-react';
export function TeslaCybertruckPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-8170">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-8171">
        <div className="container mx-auto px-4" data-id="element-8172">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-8173">
            Tesla Cybertruck Maintenance
          </h1>
          <p className="text-xl text-gray-100" data-id="element-8174">
            Expert Service for Modern Electric Vehicles
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-8175">
        <div className="max-w-4xl mx-auto" data-id="element-8176">
          {/* Hero Image */}
          <div className="mb-8" data-id="element-8177">
            <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/Tesla/Cyber-Truck-Service/Depiction%20of%20Tesla%20Cyber%20Truck%20on%20Woodward%20Ave%20in%20Birmingham%20MI%20Image%20Sep%204%2C%202025%2C%2004_22_25%20PM.png?opt=w3" alt="Tesla Cybertruck on Woodward Ave in Birmingham MI" className="w-full h-auto rounded-lg shadow-md" data-id="element-8178" />
          </div>

          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8179">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-8180">
              Tesla Cybertruck Maintenance You Can Trust
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-8181">
              The <strong data-id="element-8182">Tesla Cybertruck</strong> is one of the most advanced
              vehicles ever built—bold in design, powerful in performance, and
              engineered with cutting-edge electric technology. At{' '}
              <strong data-id="element-8183">Garrett Auto & Truck Service</strong>, we specialize in{' '}
              <strong data-id="element-8184">Cybertruck maintenance and repair</strong>, helping Tesla
              owners keep their trucks running at peak performance.
            </p>

            <div className="text-center mb-6" data-id="element-8185">
              <a href="tel:+12484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-8186">
                <Phone className="mr-3" size={24} data-id="element-8187" />
                Call 248-478-8382 Now to Schedule Your Service
              </a>
            </div>

            <p className="text-gray-700" data-id="element-8188">
              If you're searching for{' '}
              <strong data-id="element-8189">"Tesla Cybertruck maintenance near me"</strong> or{' '}
              <strong data-id="element-8190">"Cybertruck repair near me,"</strong> you've found the
              trusted local shop ready to handle all your service needs.
            </p>
          </div>

          {/* Why Choose Us */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8191">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-8192">
              Why Bring Your Cybertruck to Garrett Auto & Truck Service?
            </h2>

            <ul className="space-y-4" data-id="element-8193">
              <li className="flex items-start" data-id="element-8194">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8195" />
                <div data-id="element-8196">
                  <strong className="text-gray-900" data-id="element-8197">
                    Full-Service Tesla Cybertruck Care
                  </strong>
                  <p className="text-gray-700" data-id="element-8198">
                    Routine maintenance – we're your one-stop shop.
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-8199">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8200" />
                <div data-id="element-8201">
                  <strong className="text-gray-900" data-id="element-8202">
                    Faster, Local Service
                  </strong>
                  <p className="text-gray-700" data-id="element-8203">
                    Avoid long waits at Tesla service centers. Get your{' '}
                    <strong data-id="element-8204">Cybertruck serviced locally</strong> with expert
                    care and personal attention.
                  </p>
                </div>
              </li>
            </ul>
          </div>

          {/* Services Offered */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8205">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-8206">
              Tesla Cybertruck Maintenance Services We Offer
            </h2>

            <p className="text-gray-700 mb-6" data-id="element-8207">
              Our team is fully equipped to handle every aspect of{' '}
              <strong data-id="element-8208">Cybertruck service and repair</strong>, including:
            </p>

            <ul className="space-y-3 mb-6" data-id="element-8209">
              <li className="flex items-start" data-id="element-8210">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8211" />
                <span className="text-gray-700" data-id="element-8212">
                  <strong data-id="element-8213">Cybertruck Battery Health Checks</strong> & cooling
                  system service
                </span>
              </li>
              <li className="flex items-start" data-id="element-8214">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8215" />
                <span className="text-gray-700" data-id="element-8216">
                  <strong data-id="element-8217">Tesla Tire Service</strong> – rotations, balancing &
                  replacement for Cybertruck tires
                </span>
              </li>
              <li className="flex items-start" data-id="element-8218">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8219" />
                <span className="text-gray-700" data-id="element-8220">
                  <strong data-id="element-8221">Cybertruck Brake Service</strong> – inspections,
                  repairs & regenerative brake system support
                </span>
              </li>
              <li className="flex items-start" data-id="element-8222">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8223" />
                <span className="text-gray-700" data-id="element-8224">
                  <strong data-id="element-8225">Tesla Cybertruck Cabin Air Filter Replacement</strong>
                </span>
              </li>
              <li className="flex items-start" data-id="element-8226">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8227" />
                <span className="text-gray-700" data-id="element-8228">
                  <strong data-id="element-8229">
                    Preventative Maintenance & General Inspections
                  </strong>
                </span>
              </li>
            </ul>

            <p className="text-gray-700" data-id="element-8230">
              When it comes to <strong data-id="element-8231">Cybertruck maintenance near me</strong>,
              no one delivers better service than Garrett Auto & Truck Service.
            </p>
          </div>

          {/* Collision & Body Repairs */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8232">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-8233">
              Tesla Cybertruck Collision & Body Repairs
            </h2>

            <p className="text-gray-700 mb-4" data-id="element-8234">
              The Cybertruck's stainless steel exoskeleton is built for
              strength, but damage can still happen. Our team provides{' '}
              <strong data-id="element-8235">Tesla Cybertruck collision repair and bodywork</strong>,
              restoring both appearance and performance. From stainless steel
              dent repair to accident restoration, we have the tools and
              experience to bring your Cybertruck back to like-new condition.
            </p>
          </div>

          {/* Premier Service Center Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8236">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-8237">
              Your Premier Cybertruck Service Center
            </h2>
            <h3 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-8238">
              Garrett Auto and Truck Service
            </h3>

            <p className="text-gray-700 mb-6" data-id="element-8239">
              Looking for{' '}
              <strong data-id="element-8240">
                certified Tesla Cybertruck maintenance in Farmington Hills,
                Michigan
              </strong>
              ? Trust the experts at Garrett Auto and Truck Service—your #1
              destination for cutting-edge electric truck care. Our technicians
              stay at the forefront of Tesla technology, delivering flawless
              service, repairs, and performance upgrades for Cybertruck owners
              across Oakland and Wayne Counties. Whether you need routine
              checkups or complex diagnostics, we're the authority you can count
              on!
            </p>

            <div className="bg-blue-50 rounded-lg p-6 mb-6" data-id="element-8241">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-8242">
                <MapPin className="mr-2 text-[#B1050B]" size={24} data-id="element-8243" />
                Proudly Serving Cybertruck Owners in:
              </h3>
              <div className="flex flex-wrap gap-3" data-id="element-8244">
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8245">
                  Novi
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8246">
                  Northville
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8247">
                  Livonia
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8248">
                  West Bloomfield
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8249">
                  Southfield
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8250">
                  Bloomfield Hills
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8251">
                  Wixom
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8252">
                  Franklin
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8253">
                  Bingham Farms
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8254">
                  Beverly Hills
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8255">
                  Plymouth
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8256">
                  Orchard Lake
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8257">
                  Lathrup Village
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8258">
                  Redford
                </span>
              </div>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-8259">
              Why Choose Us for Your Tesla Cybertruck?
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-8260">
              <li className="flex items-start" data-id="element-8261">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8262" />
                <div data-id="element-8263">
                  <strong className="text-gray-900" data-id="element-8264">
                    Tesla-Certified Technicians:
                  </strong>
                  <span className="text-gray-700" data-id="element-8265">
                    {' '}
                    We use the latest Cybertruck documentation and genuine parts
                    for superior results.
                  </span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-8266">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8267" />
                <div data-id="element-8268">
                  <strong className="text-gray-900" data-id="element-8269">
                    Comprehensive Maintenance:
                  </strong>
                  <span className="text-gray-700" data-id="element-8270">
                    {' '}
                    Tire rotations, brake fluid checks, HEPA filter changes,
                    brake caliper lubrication, A/C service, Gigawiper blade
                    care, and more.
                  </span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-8271">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8272" />
                <div data-id="element-8273">
                  <strong className="text-gray-900" data-id="element-8274">EV Specialists:</strong>
                  <span className="text-gray-700" data-id="element-8275">
                    {' '}
                    Safe procedures for high-voltage systems, powertrain,
                    Autopilot/FSD calibration, and digital diagnostics.
                  </span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-8276">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8277" />
                <div data-id="element-8278">
                  <strong className="text-gray-900" data-id="element-8279">
                    Customer-First Approach:
                  </strong>
                  <span className="text-gray-700" data-id="element-8280">
                    {' '}
                    Easy scheduling, local shuttle service, and transparent
                    pricing—never any surprises.
                  </span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-8281">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8282" />
                <div data-id="element-8283">
                  <strong className="text-gray-900" data-id="element-8284">Proven Reputation:</strong>
                  <span className="text-gray-700" data-id="element-8285">
                    {' '}
                    Trusted by Tesla drivers from Farmington Hills and all
                    neighboring communities within 15 miles!
                  </span>
                </div>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-8286">
              Official Tesla Cybertruck Maintenance Schedule
            </h3>
            <div className="overflow-x-auto" data-id="element-8287">
              <table className="w-full border-collapse border border-gray-300" data-id="element-8288">
                <thead data-id="element-8289">
                  <tr className="bg-gray-100" data-id="element-8290">
                    <th className="border border-gray-300 px-4 py-3 text-left font-bold text-gray-900" data-id="element-8291">
                      Service Item
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left font-bold text-gray-900" data-id="element-8292">
                      Interval/Requirement
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left font-bold text-gray-900" data-id="element-8293">
                      Details
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-8294">
                  <tr data-id="element-8295">
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8296">
                      Tire Rotation
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8297">
                      6,250 miles or 1 year
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8298">
                      Critical for even wear and range
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-8299">
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8300">
                      Brake Fluid Check
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8301">
                      Every 4 years
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8302">
                      Replace if needed or with heavy use
                    </td>
                  </tr>
                  <tr data-id="element-8303">
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8304">
                      HEPA Cabin Air Filter
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8305">
                      Every 2 years
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8306">
                      Annually if off-roading or urban
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-8307">
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8308">
                      A/C Desiccant Bag
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8309">
                      Every 8 years
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8310">
                      Protects air conditioning system
                    </td>
                  </tr>
                  <tr data-id="element-8311">
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8312">
                      Brake Caliper Service
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8313">
                      Every 12,500 miles/annually in snowy areas
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8314">
                      Prevents road salt corrosion
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-8315">
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8316">
                      Wiper Blades and Fluid
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8317">
                      As needed
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8318">
                      OEM Gigawiper service available
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mt-6" data-id="element-8319">
              <p className="text-sm text-gray-700" data-id="element-8320">
                <strong data-id="element-8321">Official Schedule:</strong> All maintenance intervals
                based on current Tesla Cybertruck Service Manual documentation
                and certified EV repair protocols (
                <em data-id="element-8322">updated September 2025</em>).
              </p>
            </div>
          </div>

          {/* Final CTA */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8323">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-8324">
              Keep Your Tesla Cybertruck Running Strong
            </h2>
            <p className="text-gray-700 mb-6" data-id="element-8325">
              Your Tesla Cybertruck is more than a truck—it's an investment in
              the future. Protect that investment with expert{' '}
              <strong data-id="element-8326">Tesla Cybertruck maintenance and repair</strong> from
              Garrett Auto & Truck Service.
            </p>
            <p className="text-gray-700" data-id="element-8327">
              Don't wait until minor issues become major headaches. Garrett Auto
              and Truck Service delivers world-class{' '}
              <strong data-id="element-8328">Tesla Cybertruck maintenance</strong> right here in
              Farmington Hills. Join Cybertruck drivers from Novi, Northville,
              Livonia, West Bloomfield, Southfield, Bloomfield Hills, and all
              the vibrant communities nearby—who trust us with their advanced
              electric trucks.
            </p>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-8329">
            <h2 className="text-3xl font-bold mb-4" data-id="element-8330">
              Schedule Your Tesla Cybertruck Maintenance TODAY!
            </h2>
            <p className="text-xl mb-6" data-id="element-8331">
              <strong data-id="element-8332">
                Call us today to schedule your Cybertruck service appointment
                and experience the difference of expert local care.
              </strong>
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-8333">
              <Phone className="mr-3" size={24} data-id="element-8334" />
              Book Your Cybertruck Service Now - Call 248-478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-8335">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}